import { render } from "./BottomNav.vue?vue&type=template&id=10cafa38&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=10cafa38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cafa38"]])

export default __exports__